const juegoslist = [
    {
      texto: "Piter-Pal",
      img: "/imagenes/juegos/piterpal.png",
      link: "https://piterpal.pitercios.es",
      click: "juegos"
    },  
  ];
  
  export default juegoslist;